import React from 'react';

import * as ResourceApi from 'api/resources';
import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import { createButtonSectionFactory, createButtonSectionFactoryWithAdditionalArgs } from "hoc/CreateButtonSection";



export default {
    subSection: true,
    resource: false,
    hideIfResourceIsNoU: false,
    showSection: (formProxy) => {
        return formProxy.currentResource.resourceId.type === ResourceApi.Types.CompleteStep
    },

    fields: [
        {
            type: 'contenteditable',
            name: 'headline',
            required: true,
            // Headline is only allowed if there is more than one Custom HTML step
            showField: (proxy) => (proxy.currentResource.type === 'COMPLETE' && proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
            linkedField: (formProxy) => ["title"],
            props: {
                labelKey: 'editbreak.steps.complete.headline',
                // helpContent:  <CompleteHeadlineToolTip/>,
                // helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.complete.headline'}/></IntlProvider>
            }
        },
        {
            type: 'contenteditable',
            name: 'introCopy',
            required: false,
            showField: (proxy) => (proxy.currentResource.type === 'COMPLETE'),
            props: {
              labelKey: 'editbreak.steps.complete.intro_copy',
            //   helpContent:  <CompleteIntroCopyToolTip/>,
            //   helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.complete.intro_copy'}/></IntlProvider>,
              maxLength: 500,
              placeholderKey: 'editbreak.steps.complete.intro_copy.placeholder',
              validationRules: [
                  {
                      type: 'MarkupTextLimit',
                      params: {
                          limit: 500
                      }
                  }
              ]
            }
        },
        {
            type: 'contenteditable',
            name: 'description',
            required: false,
            showField: (proxy) => (proxy.currentResource.type === 'COMPLETE'),
            props: {
              labelKey: 'editbreak.steps.complete.body_copy',
              placeholderKey: 'editbreak.steps.complete.body_copy.placeholder'
            }
        },
        {
            type: 'text',
            name: 'commentQuestion',
            showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentBaseResource.sponsoredType !== 'sponsored' && proxy.currentBaseResource.type === 'COMPLETE' ),
            props: {
                labelKey: 'editbreak.steps.related_breaks.commentQuestion',
                helpContent: <FBCommentQuestionToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.fbCommentQuestion'}/></IntlProvider>
            }
        },
        // {
        //   type: 'radio',
        //   name: 'completeStepType',
        //   required: true,
        //   showField: (proxy) => (proxy.currentResource.type === 'COMPLETE'),
        //   props: {
        //     labelKey: 'editbreak.steps.complete.complete_step_type',
        //     helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.complete.complete_step_type'}/></IntlProvider>,
        //     helpContent:  <CompleteTypeToolTip/>,
        //     options: [
        //         {
        //             value: "IMAGE",
        //             textKey: 'editbreak.steps.complete.complete_step_type.image'
        //         },
        //         {
        //             value: "EMBED",
        //             textKey: 'editbreak.steps.complete.complete_step_type.embed'
        //         },
        //         {
        //             value: "VIDEO",
        //             textKey: 'editbreak.steps.complete.complete_step_type.video'
        //         }
        //     ]
        //   }
        // },
        // {
        //   type: 'image',
        //   name: 'imageId',
        //   idFor: 'image',
        //   required: true,
        //   showField: (proxy) => (proxy.currentResource.type === 'COMPLETE' && proxy.currentResource.completeStepType === 'IMAGE'),
        //   props: {
        //     labelKey: 'editbreak.steps.complete.image',
        //     imageType: 'complete',
        //     helpContent:  <CompleteImageToolTip/>,
        //     helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.complete.image'}/></IntlProvider>
        //   }
        // },
        // {
        //   type: 'textarea',
        //   name: 'embedCode',
        //   required: true,
        //   showField: (proxy) => (proxy.currentResource.type === 'COMPLETE' && (proxy.currentResource.completeStepType === 'EMBED' || proxy.currentResource.completeStepType === 'VIDEO')),
        //   props: {
        //     labelKey: 'editbreak.steps.complete.embed_code',
        //     helpContent:  <CompleteEmbedCodeToolTip/>,
        //   helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.complete.embed_code'}/></IntlProvider>
        //   }
        // },
        // {
        //   type: 'text',
        //   name: 'videoId',
        //   required: true,
        //   showField: (proxy) => (proxy.currentResource.type === 'COMPLETE' && proxy.currentResource.completeStepType === 'VIDEO'),
        //   props: {
        //     labelKey: 'editbreak.steps.complete.video_id',
        //     helpContent:  <CompleteVideoIDToolTip/>,
        //     helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.complete.video_id'}/></IntlProvider>
        //   }
        // },

        // {
        //     type: 'color',
        //     name: 'backgroundColor',
        //     props: {
        //         labelKey: 'editbreak.steps.complete.backgroundColor',
        //     }
        //   },

        //   {
        //     type: 'image',
        //     name: 'backgroundImageId',
        //     idFor: 'backgroundImage',
        //     props: {
        //         labelKey: 'editbreak.steps.complete.backgroundImage',
        //       imageType: 'stepBackgroundImage'
        //     }
        //   },

        // {
        //   type: 'textarea',
        //   name: 'nextBreakIds',
        //   required: false,
        //   showField: (proxy) => (proxy.currentResource.type === 'COMPLETE'),
        //   props: {
        //     labelKey: 'editbreak.steps.complete.next_break_ids',
        //     asList: true,
        //     helpContent:  <CompleteNextBreakURLNamesToolTip/>,
        //     helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.complete.next_break_ids'}/></IntlProvider>
        //   }
        // },
        // {
        //   type: 'textarea',
        //   name: 'excludeNextBreakIdList',
        //   required: false,
        //   showField: (proxy) => (proxy.currentResource.type === 'COMPLETE'),
        //   props: {
        //     labelKey: 'editbreak.steps.complete.exclude_next_break_ids',
        //     asList: true,
        //     helpContent:  <CompleteExcludeNextBreakURLNamesToolTip/>,
        //     helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.complete.exclude_next_break_ids'}/></IntlProvider>
        //   }
        // }

        {
            name: "linkCards",
            subSection: true,
            resource: true,
            collection: true,
            sectionWrapper: IndexedSubSectionWrapper,
            deletable: true,
            canDelete: (formProxy) => {
              // logic like this would force at least one item
              //   var parentReview = formProxy.parentCurrentResource;
              //   return parentReview.products && parentReview.products.length > 1;
                  return true
            },
            sortable: true,
            sortableName: "linksOrder",
            toggleSortLabelKey: "Re-Order",
            resourceType: ResourceApi.Types.LinkCard,
      
            props: {
              headerKey: 'editbreak.steps.grocery.checklist.section_header',
              getCustomSectionHeader: (checklist, sectionIndex) => {
                return checklist.title ? checklist.title : `link - ${ (sectionIndex + 1) }`
                // return product.dropdownTitle
                // && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
              }
            },
      
            // footerContent: createButtonSectionFactory(ResourceApi.Types.LinkCard),
            // footerContent: (props) =>  {
            //     console.log(`footerContent`, props)
            //     return createButtonSectionFactory(ResourceApi.Types.LinkCard)
            // },
            footerContent: createButtonSectionFactoryWithAdditionalArgs({
                forClass: "CompleteStep"
            }, ResourceApi.Types.LinkCard),

            // footerContent: (props) => {
            //     console.log(`footerContent`, props)
            //     console.log(`props.formProxy.currentResource`, props.formProxy.currentResource)
                
            //     return (createButtonSectionFactoryWithAdditionalArgs({
            //             createdFor: "site"

            //         }, ResourceApi.Types.LinkCard))
            // },
            




            fields: [
                {
                type: 'image',
                name: 'imageId',
                idFor: 'image',
                required: false,
                props: {
                    labelKey: 'Image',
                    imageType: 'custom',
                    helperText: '3:2 asset. Should be 666 x 444. It will be rendered at 333 x 222.'
                }
            },
            {
                    type: "text",
                    name: "eyebrow",
                    required: false,
                    props: {
                      labelKey: "eyebrow",
                    },
                },
                {
                    type: "text",
                    name: "title",
                    required: false,
                    props: {
                      labelKey: "title",
                    },
                },
    
                {
                type: "contenteditable",
                name: "body",
                required: false,
                props: {
                  labelKey: "body",
                },
              },
              {
                type: "text",
                name: "url",
                required: false,
                props: {
                  labelKey: "url",
                },
            },

            {
                type: "text",
                name: "buttonCopy",
                required: false,
                props: {
                  labelKey: "buttonCopy",
                },
            },

            ]
        }      



    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/complete.js